import { Container, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import React, { useState, useCallback, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { StatesModel } from 'client/data/models/states';
import { DataPrivacyRequestForm } from 'site-modules/data-privacy-request/components/data-privacy-request-form/data-privacy-request-form';
import { DataPrivacyRequestSuccess } from 'site-modules/data-privacy-request/components/data-privacy-request-success/data-privacy-request-success';
import { DataPrivacyRequestContent } from 'site-modules/data-privacy-request/components/data-privacy-request-content/data-privacy-request-content';
import { getSubmitQueryParam, removeSubmitQueryParam } from 'site-modules/data-privacy-request/utils/query-params';
import { descriptionSelector, titleSelector } from 'site-modules/data-privacy-request/utils/cms-content-selectors';
import { VisitorModel } from 'client/data/models/visitor';

import './data-privacy-request.scss';

export const DataPrivacyRequestUI = ({
  stateCodes = [],
  visitorId = '',
  visitorPrivacy = null,
  setModelValue,
  location: routerLocation = {},
  cmsContent = null,
}) => {
  const [isSubmitted, setSubmitted] = useState(!!getSubmitQueryParam(routerLocation));

  useEffect(() => {
    if (getSubmitQueryParam(routerLocation)) {
      removeSubmitQueryParam(routerLocation);
    }
  }, [routerLocation]);

  const handleSubmitSuccess = useCallback(() => {
    setSubmitted(true);
    window.scrollTo(0, 0);
  }, []);

  const handleSubmitAnotherRequest = useCallback(() => {
    setSubmitted(false);
  }, []);

  if (!cmsContent) {
    return null;
  }

  return (
    <Container tag="main" className="data-privacy-request" id="main-content">
      <Row className="justify-content-center pb-2 g-0">
        <Col xs={12} sm={10} md={8} className="text-gray-darker">
          <h1 className="heading-2 pt-3">{titleSelector(cmsContent)}</h1>
          {isSubmitted ? (
            <DataPrivacyRequestSuccess onSubmitAnotherRequest={handleSubmitAnotherRequest} />
          ) : (
            <Fragment>
              <DataPrivacyRequestContent className="pt-1_5 description">
                {descriptionSelector(cmsContent)}
              </DataPrivacyRequestContent>
              <hr />
              <DataPrivacyRequestForm
                onSubmitSuccess={handleSubmitSuccess}
                stateCodes={stateCodes}
                visitorId={visitorId}
                visitorPrivacy={visitorPrivacy}
                setModelValue={setModelValue}
                cmsContent={cmsContent}
              />
            </Fragment>
          )}
        </Col>
      </Row>
    </Container>
  );
};

DataPrivacyRequestUI.propTypes = {
  stateCodes: PropTypes.arrayOf(PropTypes.shape({ stateCode: PropTypes.string })),
  visitorId: PropTypes.string,
  visitorPrivacy: PropTypes.shape({
    privacy: PropTypes.shape({
      doNotSell: PropTypes.string,
    }),
  }),
  setModelValue: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  cmsContent: CmsEntities.Content,
};

export const stateToPropsConfig = {
  cmsContent: bindToContent('data-privacy-request/index'),
  stateCodes: bindToPath('allStateCodes', StatesModel),
  visitorPrivacy: bindToPath('privacy', VisitorModel),
  visitorId: bindToPath('id', VisitorModel),
};

export const DataPrivacyRequest = withRouter(connectToModel(DataPrivacyRequestUI, stateToPropsConfig));
